// import FooterV3 from './Footer-v3';
import FooterV2 from './Footer-v2';
import FooterV1 from './Footer-v1';

const Footer = process.env.GATSBY_FLAG_PRE_RELEASE === 'true' ? FooterV2 : FooterV1;

export default Footer;
